import { HTMLAttributes, FC } from 'react';
import style from './ClearanceDescription.module.scss?module';

type ClearanceDescriptionProps = {
  className?: string;
} & HTMLAttributes<HTMLParagraphElement>;

const ClearanceDescription: FC<ClearanceDescriptionProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={`w-100 m-0 ${style.clearanceDescription} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default ClearanceDescription;
